import type { LucideIcon } from "lucide-react";
import {
  Activity, Coffee, Wine, Cookie, Truck, ChefHat, Hotel, Pizza, Apple, UtensilsCrossed, PartyPopper,
} from "lucide-react";

export interface SurvivalScoreMeta {
  title: string;
  description: string;
  icon: LucideIcon;
}

const DEFAULT: SurvivalScoreMeta = {
  title: "Restaurant Survival Score",
  description: "Monthly financial health check",
  icon: Activity,
};

const MAP: Record<string, SurvivalScoreMeta> = {
  restaurant: { title: "Restaurant Survival Score", description: "Monthly financial health check", icon: UtensilsCrossed },
  "coffee-shop": { title: "Café Health Score", description: "Monthly financial health check", icon: Coffee },
  cafe: { title: "Café Health Score", description: "Monthly financial health check", icon: Coffee },
  bar: { title: "Bar Survival Score", description: "Monthly financial health check", icon: Wine },
  bakery: { title: "Bakery Health Score", description: "Monthly financial health check", icon: Cookie },
  "food-truck": { title: "Food Truck Score", description: "Monthly financial health check", icon: Truck },
  "ghost-kitchen": { title: "Ghost Kitchen Score", description: "Monthly financial health check", icon: ChefHat },
  pizzeria: { title: "Pizzeria Health Score", description: "Monthly financial health check", icon: Pizza },
  "juice-bar": { title: "Juice Bar Score", description: "Monthly financial health check", icon: Apple },
  hotel: { title: "Hotel Health Score", description: "Monthly hotel performance check", icon: Hotel },
  "hotel-fnb": { title: "Hotel Health Score", description: "Monthly hotel performance check", icon: Hotel },
  "hotel-f-b": { title: "Hotel Health Score", description: "Monthly hotel performance check", icon: Hotel },
  "airbnb-fnb": { title: "Hotel Health Score", description: "Monthly hotel performance check", icon: Hotel },
  "bed-and-breakfast": { title: "Hotel Health Score", description: "Monthly hotel performance check", icon: Hotel },
  "private-events": { title: "Events Health Score", description: "Monthly events business check", icon: PartyPopper },
  "private-chef": { title: "Private Chef Score", description: "Monthly chef services check", icon: ChefHat },
};

export function getSurvivalScoreMeta(businessType?: string | null): SurvivalScoreMeta {
  if (!businessType) return DEFAULT;
  const key = businessType.toLowerCase().trim();
  return MAP[key] ?? DEFAULT;
}
